import React, { createContext, Reducer, useContext, useReducer } from 'react';
import reducer, { initialState } from './reducer';
import { Action, State } from './types';
import * as Actions from './actions';

type ContextValue = {
  state: State;
  dispatch: React.Dispatch<Action>;
};

const Context = createContext<ContextValue>({
  state: initialState,
  dispatch: () => {},
});

const Provider = ({ children }: { children?: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Context.Provider value={{ state, dispatch }}>{children}</Context.Provider>
  );
};

function useConfigurationForm() {
  return useContext(Context);
}

export { Provider, Actions, useConfigurationForm };
